import { memo } from "react";
import { BEHAVIORAL_FLAGS, YES_NO_PARTIAL } from "../../data/scorecard";
import TextInput from "/src/components/UI/TextField/TextInput";
import { CardTitle, SegmentedChoice } from "../shared";

// "Yes" means the bad behavior WAS observed, hence the warning tones.
const FLAG_TONES = { Yes: "pink", Partially: "orange", No: "green" };

const FlagRow = memo(function FlagRow({ flag, state, onChange }) {
    const raised = state.observed === "Yes" || state.observed === "Partially";

    return (
        <div className={"ce-flag" + (raised ? " is-raised" : "")}>
            <div className="ce-flag__line">
                <span className="ce-flag__label">{flag.label}</span>
                <SegmentedChoice
                    options={YES_NO_PARTIAL}
                    value={state.observed}
                    tones={FLAG_TONES}
                    ariaLabel={`Observed: ${flag.label}`}
                    onChange={(value) => onChange(flag.id, { observed: value })}
                />
            </div>
            {raised && (
                <TextInput
                    className="ce-w100 ce-flag__notes"
                    placeholder="Notes / evidence (timestamp…)"
                    value={state.notes}
                    onChange={(event) => onChange(flag.id, { notes: event.target.value })}
                />
            )}
        </div>
    );
});

function BehavioralFlagsCard({ flags, onChange }) {
    const raisedCount = Object.values(flags).filter((flag) => flag.observed === "Yes" || flag.observed === "Partially").length;

    return (
        <section className="ce-card">
            <CardTitle
                icon="fas fa-flag"
                title="Behavioral flags"
                hint="Tick what you observed during the call"
                right={<span className={"ce-chip" + (raisedCount ? " ce-chip--pink" : "")}>{raisedCount} flagged</span>}
            />
            <div className="ce-flags">
                {BEHAVIORAL_FLAGS.map((flag) => (
                    <FlagRow key={flag.id} flag={flag} state={flags[flag.id]} onChange={onChange} />
                ))}
            </div>
        </section>
    );
}

export default memo(BehavioralFlagsCard);
